import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import RadioButton from '../../shared/RadioButton/index.jsx';
import { BackArrow } from '../../shared/svgIcons.jsx';
import { incrementStep, setFormData } from '../redux/actions';

const StepWrapper = styled.div`
  max-width: 35rem;
  width: 100%;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
`;

const RadioContainer = styled.div`
  border: 1px solid #6d6d6d;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;
`;

const BlurredText = styled.p`
  filter: blur(2px);
  margin-top: 0;
  padding-bottom: 1.5rem;
`;

const HalfRadioContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const mapStateToProps = state => ({
  formData: state.formData,
  role: state.formData.role,
  didInstallRoof: state.formData.didInstallRoof,
});

const RoleWarning = ({ clearValues }) => {
  _satellite.track('form-error', {
    errorCode: 'NA',
    errorMsg: 'The person purchasing the property fill out the transfer request form',
  });

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Transfer"
        data-track-form-step="step 1 - role"
        onClick={() => clearValues()}
      >
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BlurredText>What is your role?</BlurredText>
      </BackWrapper>
      <Header>One of our representatives can better assist with your transfer request.</Header>
      <p>
        We recommend that the person purchasing the property fill out the transfer request form, as we will need the new
        property owner’s contact information and proof of property ownership.
      </p>
      <p>
        If you would prefer to handle the warranty transfer as the seller of the property, please contact one of our
        representatives at:
      </p>
      <Header>1-800-ROOFING</Header>
    </StepWrapper>
  );
};

const InstallWarning = ({ clearValues }) => {
  _satellite.track('form-error', {
    errorCode: 'NA',
    errorMsg: 'You may only transfer this warranty one time',
  });

  return (
    <StepWrapper>
      <BackWrapper onClick={() => clearValues()}>
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BlurredText>What is your role?</BlurredText>
      </BackWrapper>
      <Header>One of our representatives can better assist with your transfer request.</Header>
      <p>
        You may only transfer this warranty one time, anytime during the life of the warranty, to the purchasers of the
        structure on which the shingles are installed.
      </p>
      <p>Please contact one of our representatives at:</p>
      <Header>1-800-ROOFING</Header>
    </StepWrapper>
  );
};

const Step1 = ({ incrementStep, setFormData, role, didInstallRoof, formData }) => {
  const validated = role == 'buyer' && didInstallRoof === 'true';
  const showRoleWarning = formData.role == 'seller';
  const showInstallWarning = formData.didInstallRoof === 'false';

  function roleSelect(event) {
    setFormData({ role: event.target.value });
  }

  function handleInstalledRoofChange(event) {
    setFormData({ didInstallRoof: event.target.value });
  }

  function clearValues() {
    setFormData({ role: '', didInstallRoof: '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (showRoleWarning || showInstallWarning) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <StepWrapper>
      {showRoleWarning && <RoleWarning clearValues={() => clearValues()} />}
      {showInstallWarning && <InstallWarning clearValues={() => clearValues()} />}
      {!(showInstallWarning || showRoleWarning) && (
        <div>
          <p>Let’s get started! First,</p>
          <Header>What is your role?</Header>
          <div onChange={event => roleSelect(event)}>
            <RadioContainer>
              <RadioButton value="seller" fieldKey="role" htmlAttributes={{}}>
                <label>
                  I am the person <strong>selling</strong> the property
                </label>
              </RadioButton>
            </RadioContainer>
            <RadioContainer>
              <RadioButton value="buyer" fieldKey="role" htmlAttributes={{}}>
                <label>
                  I am the person <strong>buying</strong> the property
                </label>
              </RadioButton>
            </RadioContainer>
          </div>

          <div style={{ display: formData.role === 'buyer' ? 'block' : 'none' }}>
            <Header>Did the seller install / have the roof installed?</Header>
            <HalfRadioContainer onChange={event => handleInstalledRoofChange(event)}>
              <RadioContainer>
                <RadioButton value="true" fieldKey="didInstallRoof" htmlAttributes={{}}>
                  <label>Yes</label>
                </RadioButton>
              </RadioContainer>
              <RadioContainer>
                <RadioButton value="false" fieldKey="didInstallRoof" htmlAttributes={{}}>
                  <label>No</label>
                </RadioButton>
              </RadioContainer>
            </HalfRadioContainer>
          </div>

          <NextButton
            data-track="form-advance"
            data-track-form-name="Warranty Transfer"
            data-track-form-step="step 1 - role"
            onClick={incrementStep}
            disabled={!validated}
          >
            Next
          </NextButton>
        </div>
      )}
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
